"use strict";
import { MenuLink } from "components/NavBar/CompanyMenu/MenuDropdown";
import { NavDropdown } from "components/NavBar/NavDropdown";
import { getSettingsViewIndex } from "components/NavBar/PreferencesMenu";
import { PreferencesView } from "components/NavBar/PreferencesMenu/shared";
import { useEffect, useRef, useState } from "react";
import { useMenuContent } from "./Content";
import { Accordion, AnimateTransition, Flex } from "ui/src";
import { TestID } from "test/fixtures/testIDs";
export function MobileMenuDrawer({ isOpen, closeMenu }) {
  const [openSections, setOpenSections] = useState();
  const [settingsView] = useState(PreferencesView.SETTINGS);
  const dropdownRef = useRef(null);
  const menuContent = useMenuContent();
  useEffect(() => {
    if (!isOpen) {
      setTimeout(() => setOpenSections([]), 300);
    }
  }, [isOpen]);
  return <NavDropdown dropdownRef={dropdownRef} isOpen={isOpen} dataTestId={TestID.CompanyMenuMobileDrawer}>
      <Flex pt="$spacing12" pb="$spacing32" px="$spacing24">
        <AnimateTransition
    currentIndex={getSettingsViewIndex(settingsView)}
    animationType={settingsView === PreferencesView.SETTINGS ? "forward" : "backward"}
  >
          <Accordion
    overflow="hidden"
    width="100%"
    type="multiple"
    value={openSections}
    onValueChange={setOpenSections}
  >
            <Flex gap="$spacing12" mb={"$spacing60"}>
              {menuContent.map((tab, index) => <MenuLink
    key={`${tab.title}_${index}}`}
    title={tab.title}
    href={tab.href}
    icon={tab.icon}
    internal
    closeMenu={closeMenu}
  />)}
            </Flex>
          </Accordion>
        </AnimateTransition>
      </Flex>
    </NavDropdown>;
}
